import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AbstractSelectComponent } from '@connect-services/src/lib/components/abstract-select.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

const readonlyOptionHeight = 35;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-readonly-dropdown-list',
    styleUrl: './readonly-dropdown-list.component.scss',
    templateUrl: './readonly-dropdown-list.component.html',
})
export class ReadonlyDropdownListComponent<T> extends AbstractSelectComponent<T> {
    public readonly maxVisibleOptions = input<number>(5);

    public override onInputClick(event: MouseEvent): void {
        event.stopPropagation();
    }

    public override onSelectedClick(event: MouseEvent): void {
        event.stopPropagation();

        this.toggleSelect();
    }

    protected override recomputeDropdownMaxHeight(): void {
        this.dropdownMaxHeight = this.maxVisibleOptions() * readonlyOptionHeight;
    }
}
